module.exports = __webpack_public_path__ + "img/bsa1.8d5ac31b.png";